import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from './components/Navbar';
import Routing from './route/Routing';

function App() {
  return (
    <div className='bg-light-theme'>
      <Navbar />
      <Routing/>
      <div className="container mx-auto flex flex-col gap-3">
      </div>
    </div>
  );
}

export default App;
